import axios from "../service/HttpRequestBibomartNet";

function getListBank(){
    return axios.get('/customer-affiliate/v1/common/bank');
}


export {
    getListBank
}